import { WorkingHoursType } from "../../../shared/enums/workingHoursType.enum";

export interface WorkingHoursInitialState {
    company: string | undefined;
    department: string | undefined;
    forklit: string | undefined;
    showFilters: boolean;
    viewType: 'Table' | 'New' | 'Update';
    tableType: WorkingHoursType;
}

const initialWorkingHoursState: WorkingHoursInitialState = {
    company: undefined,
    department: undefined,
    forklit: undefined,
    showFilters: true,
    viewType: 'Table',
    tableType: WorkingHoursType.Company
}

export default initialWorkingHoursState